<template>
	<div>
		<!--  BEGIN NAVBAR  -->
		<div class="header-container fixed-top">
			<header class="header navbar navbar-expand-sm">
				<ul class="navbar-item theme-brand flex-row text-center">
					<li class="nav-item theme-logo">
						<router-link to="">
							<img src="@/assets/images/logo.svg" class="navbar-logo" alt="logo" />
						</router-link>
					</li>
					<li class="nav-item theme-text">
						<router-link to="" class="nav-link"> E-Tourism </router-link>
					</li>
				</ul>
				<div class="d-none horizontal-menu">
					<a href="javascript:void(0);" class="sidebarCollapse" data-placement="bottom"
						@click="$store.commit('toggleSideBar', !$store.state.is_show_sidebar)">
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
							stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
							class="feather feather-menu">
							<line x1="3" y1="12" x2="21" y2="12"></line>
							<line x1="3" y1="6" x2="21" y2="6"></line>
							<line x1="3" y1="18" x2="21" y2="18"></line>
						</svg>
					</a>
				</div>

				<div class="navbar-item flex-row ms-md-auto">
					<div class="dark-mode d-flex align-items-center">
						<a v-if="$store.state.dark_mode == 'light'" href="javascript:;" class="d-flex align-items-center"
							@click="toggleMode('dark')">
							<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
								stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
								class="feather feather-sun">
								<circle cx="12" cy="12" r="5"></circle>
								<line x1="12" y1="1" x2="12" y2="3"></line>
								<line x1="12" y1="21" x2="12" y2="23"></line>
								<line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
								<line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
								<line x1="1" y1="12" x2="3" y2="12"></line>
								<line x1="21" y1="12" x2="23" y2="12"></line>
								<line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
								<line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
							</svg>
							<span class="ms-2">Light</span>
						</a>
						<a v-if="$store.state.dark_mode == 'dark'" href="javascript:;" class="d-flex align-items-center"
							@click="toggleMode('system')">
							<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
								stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
								class="feather feather-moon">
								<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
							</svg>
							<span class="ms-2">Dark</span>
						</a>
						<a v-if="$store.state.dark_mode == 'system'" href="javascript:;" class="d-flex align-items-center"
							@click="toggleMode('light')">
							<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
								stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
								class="feather feather-airplay">
								<path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1">
								</path>
								<polygon points="12 15 17 21 7 21 12 15"></polygon>
							</svg>
							<span class="ms-2">System</span>
						</a>
					</div>

					<div class="dropdown nav-item language-dropdown btn-group">
						<a href="javascript:;" id="ddllang" data-bs-toggle="dropdown" aria-expanded="false"
							class="btn dropdown-toggle btn-icon-only nav-link">
							<img v-if="selectedLang" :src="require(`@/assets/images/flags/${selectedLang.code}.png`)"
								class="flag-width" alt="flag" />
						</a>
						<ul class="dropdown-menu" aria-labelledby="ddllang">
							<perfect-scrollbar>
								<li v-for="item in countryList" :key="item.code">
									<a href="javascript:;" class="dropdown-item d-flex align-items-center"
										:class="{ active: $i18n.locale === item.code }" @click.prevent="changeLanguage(item)">
										<img :src="require(`@/assets/images/flags/${item.code}.png`)" class="flag-width" alt="" /> <span>{{
												item.name
										}}</span>
									</a>
								</li>
							</perfect-scrollbar>
						</ul>
					</div>

					<div class="dropdown nav-item user-profile-dropdown btn-group">
						<a href="javascript:;" id="ddluser" data-bs-toggle="dropdown" aria-expanded="false"
							class="btn dropdown-toggle btn-icon-only user nav-link">
							<img src="@/assets/images/myAvatar.jpg" alt="avatar" />
						</a>
						<ul class="dropdown-menu dropdown-menu-right" aria-labelledby="ddluser">
							<li role="presentation">
								<router-link :to="{ name: 'ProfilePage' }" class="dropdown-item">
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
										stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
										class="feather feather-user">
										<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
										<circle cx="12" cy="7" r="4"></circle>
									</svg>
									{{ $t('Profile') }}
								</router-link>
							</li>
							<li role="presentation">
								<router-link :to="{ name: 'ChangePasswordPage' }" class="dropdown-item">
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
										stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
										class="feather feather-lock">
										<rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
										<path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
									</svg>
									{{ $t('Change Password') }}
								</router-link>
							</li>
							<li role="presentation">
								<a class="dropdown-item" href="javascript:void(0)" @click.prevent="logoutAction">
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
										stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
										class="feather feather-log-out">
										<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
										<polyline points="16 17 21 12 16 7"></polyline>
										<line x1="21" y1="12" x2="9" y2="12"></line>
									</svg>
									Sign Out
								</a>
							</li>
						</ul>
					</div>
				</div>
			</header>
		</div>
		<!--  END NAVBAR  -->
		<!--  BEGIN NAVBAR  -->
		<div class="sub-header-container">
			<header class="header navbar navbar-expand-sm">
				<a href="javascript:void(0);" class="sidebarCollapse" data-placement="bottom"
					@click="$store.commit('toggleSideBar', !$store.state.is_show_sidebar)">
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
						stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
						class="feather feather-menu">
						<line x1="3" y1="12" x2="21" y2="12"></line>
						<line x1="3" y1="6" x2="21" y2="6"></line>
						<line x1="3" y1="18" x2="21" y2="18"></line>
					</svg>
				</a>

				<!-- Portal vue/Teleport for Breadcrumb -->
				<div id="breadcrumb" class="vue-portal-target"></div>
			</header>
		</div>
		<!--  END NAVBAR  -->
		<!--  BEGIN TOPBAR  -->
		<div class="topbar-nav header navbar" role="banner">
			<nav class="topbar">
				<ul class="list-unstyled menu-categories" id="topAccordion">
					<li class="menu single-menu">
						<a href="javascript:;" class="dropdown-toggle autodroprown">
							<div class="">
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
									stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
									class="feather feather-home">
									<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
									<polyline points="9 22 9 12 15 12 15 22"></polyline>
								</svg>
								<span>{{ $t('dashboard') }}</span>
							</div>
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
								stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
								class="feather feather-chevron-down">
								<polyline points="6 9 12 15 18 9"></polyline>
							</svg>
						</a>
						<ul class="collapse submenu list-unstyled">
							<li>
								<router-link to=""> {{ $t('sales') }} </router-link>
							</li>
							<li>
								<router-link to="">{{ $t('analytics') }}</router-link>
							</li>
						</ul>
					</li>

					<li class="menu single-menu">
						<a href="javascript:;" class="dropdown-toggle">
							<div class="">
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
									stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
									class="feather feather-cpu">
									<rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect>
									<rect x="9" y="9" width="6" height="6"></rect>
									<line x1="9" y1="1" x2="9" y2="4"></line>
									<line x1="15" y1="1" x2="15" y2="4"></line>
									<line x1="9" y1="20" x2="9" y2="23"></line>
									<line x1="15" y1="20" x2="15" y2="23"></line>
									<line x1="20" y1="9" x2="23" y2="9"></line>
									<line x1="20" y1="14" x2="23" y2="14"></line>
									<line x1="1" y1="9" x2="4" y2="9"></line>
									<line x1="1" y1="14" x2="4" y2="14"></line>
								</svg>
								<span>{{ $t('apps') }}</span>
							</div>
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
								stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
								class="feather feather-chevron-down">
								<polyline points="6 9 12 15 18 9"></polyline>
							</svg>
						</a>
						<ul class="collapse submenu list-unstyled">
							<li>
								<router-link to="">Chat</router-link>
							</li>
							<li>
								<router-link to="">Mailbox</router-link>
							</li>
							<li>
								<router-link to="">Todo List</router-link>
							</li>
							<li>
								<router-link to="">Notes</router-link>
							</li>
							<li>
								<router-link to="">Scrumboard</router-link>
							</li>
							<li>
								<router-link to="">Contacts</router-link>
							</li>

							<li class="sub-sub-submenu-list">
								<a href="javascript:;">
									Invoice
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
										stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
										class="feather feather-chevron-right">
										<polyline points="9 18 15 12 9 6"></polyline>
									</svg>
								</a>
								<ul class="collapse list-unstyled sub-submenu">
									<li>
										<router-link to="">List</router-link>
									</li>
									<li>
										<router-link to="">Preview</router-link>
									</li>
									<li>
										<router-link to="">Add</router-link>
									</li>
									<li>
										<router-link to="">Edit</router-link>
									</li>
								</ul>
							</li>
							<li>
								<router-link to="">Calendar</router-link>
							</li>
						</ul>
					</li>

					<li class="menu single-menu">
						<a href="javascript:;" class="dropdown-toggle">
							<div class="">
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
									stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
									class="feather feather-box">
									<path
										d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z">
									</path>
									<polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
									<line x1="12" y1="22.08" x2="12" y2="12"></line>
								</svg>
								<span>{{ $t('components') }}</span>
							</div>
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
								stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
								class="feather feather-chevron-down">
								<polyline points="6 9 12 15 18 9"></polyline>
							</svg>
						</a>
						<ul class="collapse submenu list-unstyled">
							<li>
								<router-link to="">Tabs</router-link>
							</li>
							<li>
								<router-link to="">Accordions</router-link>
							</li>
							<li>
								<router-link to="">Modals</router-link>
							</li>
							<li>
								<router-link to="">Cards</router-link>
							</li>
							<li>
								<router-link to="">Carousel</router-link>
							</li>
							<li>
								<router-link to="">Countdown</router-link>
							</li>
							<li>
								<router-link to="">Counter</router-link>
							</li>
							<li>
								<router-link to="">Sweet Alerts</router-link>
							</li>
							<li>
								<router-link to="">Timeline</router-link>
							</li>
							<li>
								<router-link to="">Notifications</router-link>
							</li>
							<li>
								<router-link to="">Media Object</router-link>
							</li>
							<li>
								<router-link to="">List Group</router-link>
							</li>
							<li>
								<router-link to="">Pricing Tables</router-link>
							</li>
							<li>
								<router-link to=""> Lightbox </router-link>
							</li>
						</ul>
					</li>

					<li class="menu single-menu">
						<a href="javascript:;" class="dropdown-toggle">
							<div class="">
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
									stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
									class="feather feather-zap">
									<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
								</svg>
								<span>{{ $t('ui_kit') }}</span>
							</div>
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
								stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
								class="feather feather-chevron-down">
								<polyline points="6 9 12 15 18 9"></polyline>
							</svg>
						</a>
						<ul class="collapse submenu list-unstyled">
							<li>
								<router-link to="">Alerts</router-link>
							</li>
							<li>
								<router-link to="">Avatar</router-link>
							</li>
							<li>
								<router-link to="">Badges</router-link>
							</li>
							<li>
								<router-link to="">Breadcrumbs</router-link>
							</li>
							<li>
								<router-link to="">Buttons</router-link>
							</li>
							<li>
								<router-link to="">Button Groups</router-link>
							</li>
							<li>
								<router-link to="">Color Library</router-link>
							</li>
							<li>
								<router-link to="">Dropdown</router-link>
							</li>
							<li>
								<router-link to="">Infobox</router-link>
							</li>
							<li>
								<router-link to="">Jumbotron</router-link>
							</li>
							<li>
								<router-link to="">Loader</router-link>
							</li>
							<li>
								<router-link to="">Pagination</router-link>
							</li>
							<li>
								<router-link to="">Popovers</router-link>
							</li>
							<li>
								<router-link to="">Progress Bar</router-link>
							</li>
							<li>
								<router-link to="">Search</router-link>
							</li>
							<li>
								<router-link to="">Tooltips</router-link>
							</li>
							<li>
								<router-link to="">Treeview</router-link>
							</li>
							<li>
								<router-link to="">Typography</router-link>
							</li>
						</ul>
					</li>

					<li class="menu single-menu">
						<a href="javascript:;" class="dropdown-toggle">
							<div class="">
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
									stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
									class="feather feather-layout">
									<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
									<line x1="3" y1="9" x2="21" y2="9"></line>
									<line x1="9" y1="21" x2="9" y2="9"></line>
								</svg>
								<span>{{ $t('tables') }}</span>
							</div>
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
								stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
								class="feather feather-chevron-down">
								<polyline points="6 9 12 15 18 9"></polyline>
							</svg>
						</a>
						<ul class="collapse submenu list-unstyled">
							<li>
								<router-link to="">Basic</router-link>
							</li>
							<li class="sub-sub-submenu-list">
								<a href="javascript:;" class="dropdown-toggle">
									DataTables
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
										stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
										class="feather feather-chevron-right">
										<polyline points="9 18 15 12 9 6"></polyline>
									</svg>
								</a>
								<ul class="collapse list-unstyled sub-submenu">
									<li>
										<router-link to="">Basic</router-link>
									</li>
									<li>
										<router-link to="">Striped Table</router-link>
									</li>
									<li>
										<router-link to="">Order Sorting</router-link>
									</li>
									<li>
										<router-link to="">Multi Column</router-link>
									</li>
									<li>
										<router-link to="">Multiple Tables</router-link>
									</li>
									<li>
										<router-link to="">Alt. Pagination</router-link>
									</li>
									<li>
										<router-link to="">Custom</router-link>
									</li>
									<li>
										<router-link to="">Range Search</router-link>
									</li>
									<li>
										<router-link to="">Export</router-link>
									</li>
									<li>
										<router-link to="">Live DOM ordering
										</router-link>
									</li>
									<li>
										<router-link to="">Miscellaneous</router-link>
									</li>
								</ul>
							</li>
						</ul>
					</li>

					<li class="menu single-menu">
						<a href="javascript:;" class="dropdown-toggle">
							<div class="">
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
									stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
									class="feather feather-clipboard">
									<path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2">
									</path>
									<rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
								</svg>
								<span>{{ $t('forms') }}</span>
							</div>
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
								stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
								class="feather feather-chevron-down">
								<polyline points="6 9 12 15 18 9"></polyline>
							</svg>
						</a>
						<ul class="collapse submenu list-unstyled">
							<li>
								<router-link to="">Basic</router-link>
							</li>
							<li>
								<router-link to="">Input Group</router-link>
							</li>
							<li>
								<router-link to="">Layouts</router-link>
							</li>
							<li>
								<router-link to="">Validation</router-link>
							</li>
							<li>
								<router-link to="">Input Mask</router-link>
							</li>
							<li>
								<router-link to="">Select2</router-link>
							</li>
							<li>
								<router-link to="">TouchSpin</router-link>
							</li>
							<li>
								<router-link to="">Checkbox &amp; Radio</router-link>
							</li>
							<li>
								<router-link to="">Switches</router-link>
							</li>
							<li>
								<router-link to="">Wizards</router-link>
							</li>
							<li>
								<router-link to="">File Upload</router-link>
							</li>
							<li>
								<router-link to="">Quill Editor</router-link>
							</li>
							<li>
								<router-link to="">Markdown Editor</router-link>
							</li>
							<li>
								<router-link to="">Date &amp; Range Picker </router-link>
							</li>
							<li>
								<router-link to="">Clipboard</router-link>
							</li>
						</ul>
					</li>

					<li class="menu single-menu">
						<a href="javascript:;" class="dropdown-toggle">
							<div class="">
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
									stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
									class="feather feather-file">
									<path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
									<polyline points="13 2 13 9 20 9"></polyline>
								</svg>
								<span>{{ $t('pages') }}</span>
							</div>
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
								stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
								class="feather feather-chevron-down">
								<polyline points="6 9 12 15 18 9"></polyline>
							</svg>
						</a>
						<ul class="collapse submenu list-unstyled">
							<li>
								<router-link to="">Helpdesk</router-link>
							</li>
							<li>
								<router-link to="">Contact Form</router-link>
							</li>
							<li>
								<router-link to="">FAQ</router-link>
							</li>
							<li>
								<router-link to="">FAQ 2</router-link>
							</li>
							<li>
								<router-link to="">Privacy Policy</router-link>
							</li>
							<li><a target="_blank" href="">Coming Soon</a></li>
							<li>
								<router-link to="">Blank Page</router-link>
							</li>
							<li>
								<router-link to="">Sample Page</router-link>
							</li>

							<li>
								<router-link to="">Profile</router-link>
							</li>
							<li>
								<router-link to="">Account Settings</router-link>
							</li>
							<li class="sub-sub-submenu-list">
								<a href="javascript:;" class="dropdown-toggle">
									Error
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
										stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
										class="feather feather-chevron-right">
										<polyline points="9 18 15 12 9 6"></polyline>
									</svg>
								</a>
								<ul class="collapse list-unstyled sub-submenu">
									<li><a target="_blank" href="/pages/error404">404</a></li>
									<li><a target="_blank" href="/pages/error500">500</a></li>
									<li><a target="_blank" href="/pages/error503">503</a></li>
									<li><a target="_blank" href="/pages/maintenence">Maintanence</a></li>
								</ul>
							</li>
							<li class="sub-sub-submenu-list">
								<a href="javascript:;" class="dropdown-toggle">
									Login
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
										stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
										class="feather feather-chevron-right">
										<polyline points="9 18 15 12 9 6"></polyline>
									</svg>
								</a>
								<ul class="collapse list-unstyled sub-submenu">
									<li><a target="_blank" href="/auth/login">Login Cover</a></li>
									<li><a target="_blank" href="/auth/login-boxed">Login Boxed</a></li>
								</ul>
							</li>
							<li class="sub-sub-submenu-list">
								<a href="javascript:;" class="dropdown-toggle">
									Register
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
										stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
										class="feather feather-chevron-right">
										<polyline points="9 18 15 12 9 6"></polyline>
									</svg>
								</a>
								<ul class="collapse list-unstyled sub-submenu">
									<li><a target="_blank" href="/auth/register">Register Cover</a></li>
									<li><a target="_blank" href="/auth/register-boxed">Register Boxed</a></li>
								</ul>
							</li>

							<li class="sub-sub-submenu-list">
								<a href="javascript:;" class="dropdown-toggle">
									Password Recovery
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
										stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
										class="feather feather-chevron-right">
										<polyline points="9 18 15 12 9 6"></polyline>
									</svg>
								</a>
								<ul class="collapse list-unstyled sub-submenu">
									<li><a target="_blank" href="/auth/pass-recovery">Recover ID Cover</a></li>
									<li><a target="_blank" href="/auth/pass-recovery-boxed">Recover ID Boxed</a>
									</li>
								</ul>
							</li>

							<li class="sub-sub-submenu-list">
								<a href="javascript:;" class="dropdown-toggle">
									Lockscreen
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
										stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
										class="feather feather-chevron-right">
										<polyline points="9 18 15 12 9 6"></polyline>
									</svg>
								</a>
								<ul class="collapse list-unstyled sub-submenu">
									<li><a target="_blank" href="/auth/lockscreen">Unlock Cover</a></li>
									<li><a target="_blank" href="/auth/lockscreen-boxed">Unlock Boxed</a></li>
								</ul>
							</li>
						</ul>
					</li>

					<li class="menu single-menu">
						<a href="javascript:;" class="dropdown-toggle">
							<div class="">
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
									stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
									class="feather feather-plus-circle">
									<circle cx="12" cy="12" r="10"></circle>
									<line x1="12" y1="8" x2="12" y2="16"></line>
									<line x1="8" y1="12" x2="16" y2="12"></line>
								</svg>
								<span>{{ $t('more') }}</span>
							</div>
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
								stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
								class="feather feather-chevron-down">
								<polyline points="6 9 12 15 18 9"></polyline>
							</svg>
						</a>
						<ul class="collapse submenu list-unstyled">
							<li>
								<router-link to="">Drag and Drop</router-link>
							</li>
							<li>
								<router-link to="">Widgets</router-link>
							</li>
							<li>
								<router-link to="">Charts</router-link>
							</li>
							<li>
								<router-link to="">Font Icons</router-link>
							</li>
							<li>
								<a target="_blank" href="https://cork-vue.sbthemes.com"> Documentation </a>
							</li>
						</ul>
					</li>
				</ul>
			</nav>
		</div>
		<!--  END TOPBAR  -->
	</div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { useLoginStore } from '@/store/auth/LoginStore';
import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';

const store = useStore();

const selectedLang = ref(null);
const countryList = ref(store.state.countryList);

const i18n = useI18n();

onMounted(() => {
	selectedLang.value = window.$appSetting.toggleLanguage();
	toggleMode();
});

const toggleMode = (mode) => {
	window.$appSetting.toggleMode(mode);
};

const changeLanguage = (item) => {
	selectedLang.value = item;
	window.$appSetting.toggleLanguage(item);

	i18n.locale.value = item.code;
};

// logout
const loginStore = useLoginStore();
const logoutAction = async () => {
	await loginStore.logout();
	if (!loginStore.isAuthenticated) {
		top.location = '/login';
	}
};
</script>
